import * as React from 'react';
import styled from 'styled-components';

import { TextOnlyEditor } from '../../BlogEditor/TextOnlyEditor';
import { colorsV2 } from '../../colors-v2';
import { shadows } from '../../shadows';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { ButtonIconAudio } from './ButtonIconAudio';

const Container = styled.div`
  border: 1px solid ${colorsV2.blue60};
  border-radius: 8px;

  position: relative;
  .title {
    position: absolute;
    top: -20px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: fit-content;

    padding: 10px 12px;
    border-radius: 20px;
    border: 1px solid ${colorsV2.blue60};
    background-color: ${colorsV2.white100};
  }

  .content {
    background-color: ${colorsV2.blue5};
    padding: 32px 24px 16px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${colorsV2.blue60};

    display: flex;
    justify-content: space-between;

    .part-of-speech {
      font-style: italic;
      text-transform: lowercase;
    }
  }
  .description {
    background: ${colorsV2.white100};
    padding: 16px 24px 24px;
    box-shadow: ${shadows.zIndex4};
    border-radius: 0 0 8px 8px;

    .text-only-editor-body {
      .dol-editor {
        font-family: Inter, sans-serif;
        padding: 0;
        background-color: transparent;

        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

interface CardVocabDetailProps {
  word: string;
  partOfSpeech: string;
  pronunciation: string;
  definition: string;
  example: any;
}

export const CardVocabDetail = (props: CardVocabDetailProps) => {
  const { word, partOfSpeech, pronunciation, definition, example } = props;

  const exampleObj = React.useMemo(() => {
    return typeof example?.content === 'string' ? JSON.parse(example.content) : example.content;
  }, [example]);

  return (
    <Container>
      <div className="title">
        <ResponsiveTypography.Title as="h2" variant="bold/14-20" color="blue100">
          TỪ VỰNG HÔM NAY
        </ResponsiveTypography.Title>
      </div>
      <div className="content">
        <div className="word">
          <ResponsiveTypography.Paragraph color="black100" variant="semi-bold/20-28">
            {word}
          </ResponsiveTypography.Paragraph>
          <ResponsiveTypography.Paragraph
            color="black80"
            variant="regular/14-20"
            className="part-of-speech"
          >
            {partOfSpeech}
          </ResponsiveTypography.Paragraph>
          <ResponsiveTypography.Paragraph color="black80" variant="regular/14-20">
            {pronunciation}
          </ResponsiveTypography.Paragraph>
        </div>
        <div className="action">
          <ButtonIconAudio textToPlayAudio={word} />
        </div>
      </div>
      <div className="description">
        <ResponsiveTypography.Paragraph color="black100" variant="regular/14-20" mb="24px">
          {definition}
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph color="black100" variant="semi-bold/14-20" mb="4px">
          Example
        </ResponsiveTypography.Paragraph>
        <div className="example-content">
          <TextOnlyEditor stickDirection="left" isReadOnly initialValue={exampleObj} />
        </div>
      </div>
    </Container>
  );
};
